import { type CarrierDef } from '../common.js'
import { type DocumentType } from '../document-types.js'
import { password, username } from '../internal.js'

const credentialTypes = [username, password] as const

export type cffoCredType = (typeof credentialTypes)[number]

export const cffoDocumentTypes = [
  'invoice',
  'proof-of-delivery',
  'signed-bol',
] as const satisfies readonly DocumentType[]

export const cffo: CarrierDef<cffoCredType> = {
  name: 'Consolidated Fastfrate',
  scac: 'cffo',
  credentialTypes,
  engineLayers: ['documents'],
  documentTypes: cffoDocumentTypes,
}
